import React from 'react';
import { t } from 'ttag';
import { CyberSecurityData } from '../..';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import Turtle from '../../characters/Turtle';

const TurtleIntro: React.FC<ISlide<CyberSecurityData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: Turtle,
            text: t`${data.name}, I’m glad you found me! We have had some problems with our villagers’ personal information being stolen.`,
            textSpriteName: 'turtle-3-1',
            buttonText: t`Personal Information?`,
        },
        {
            character: Turtle,
            text: t`Personal information is data such as your name, date of birth or address. Let me show you what your information looks like.`,
            textSpriteName: 'turtle-3-2',
            buttonText: t`Okay!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default TurtleIntro;
